var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvoice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.419 87.636H10.7012V11.3483C10.7012 7.00734 14.2202 3.48828 18.5612 3.48828H82.1398C77.7981 3.48828 74.2791 7.00734 74.2791 11.3483V79.776C74.2791 84.1169 70.76 87.636 66.419 87.636Z",
    fill: "url(#paint0_linear_2510_31734)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2797 37.0391L51.1315 13.8909C49.1073 11.6202 45.9899 10.1638 42.4908 10.1638C36.3893 10.1638 31.4434 14.5865 31.4434 20.0433V22.3786C31.4434 25.121 32.6931 27.6012 34.7104 29.3913L74.2797 68.9606V37.0391Z",
    fill: "url(#paint1_linear_2510_31734)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2793 21.6198H88.3294C89.2523 21.6198 90 20.8714 90 19.9492V11.3483C90 7.00734 86.481 3.48828 82.14 3.48828C77.7984 3.48828 74.28 7.00734 74.28 11.3483V21.6198H74.2793Z",
    fill: "url(#paint2_linear_2510_31734)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6716 84.5372L58.3791 70.244C58.079 69.7983 57.5695 69.5051 56.9921 69.5051H10.7012V87.636H66.419C68.9699 87.636 71.2358 86.42 72.6716 84.5372Z",
    fill: "url(#paint3_linear_2510_31734)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5215 87.636H7.8614C3.51837 87.636 0 84.1156 0 79.7746V71.1757C0 70.2529 0.747757 69.5051 1.67061 69.5051H56.9923C57.9151 69.5051 58.6629 70.2529 58.6629 71.1757V79.7746C58.6629 84.1156 62.1812 87.636 66.5215 87.636Z",
    fill: "url(#paint4_linear_2510_31734)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2534 87.603V87.636H66.5215C66.768 87.636 67.0117 87.6243 67.2534 87.603Z",
    fill: "url(#paint5_linear_2510_31734)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M38.379 39.1808H16.464C16.1921 39.1808 15.9717 38.961 15.9717 38.6891V37.3742C15.9717 37.103 16.1921 36.8826 16.464 36.8826H38.379C38.6502 36.8826 38.8706 37.103 38.8706 37.3742V38.6891C38.8706 38.961 38.6502 39.1808 38.379 39.1808Z",
    fill: "url(#paint6_linear_2510_31734)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5831 39.1808H41.2328C40.9616 39.1808 40.7412 38.961 40.7412 38.6891V37.3742C40.7412 37.103 40.9616 36.8826 41.2328 36.8826H49.5831C49.8551 36.8826 50.0755 37.103 50.0755 37.3742V38.6891C50.0748 38.961 49.8551 39.1808 49.5831 39.1808Z",
    fill: "url(#paint7_linear_2510_31734)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5171 39.1808H52.6583C52.3864 39.1808 52.166 38.961 52.166 38.6891V37.3742C52.166 37.103 52.3864 36.8826 52.6583 36.8826H68.5171C68.789 36.8826 69.0094 37.103 69.0094 37.3742V38.6891C69.0094 38.961 68.789 39.1808 68.5171 39.1808Z",
    fill: "url(#paint8_linear_2510_31734)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.602 43.5588H68.517C68.7889 43.5588 69.0093 43.7793 69.0093 44.0512V45.3661C69.0093 45.6373 68.7889 45.8577 68.517 45.8577H46.602C46.3308 45.8577 46.1104 45.6373 46.1104 45.3661V44.0512C46.1104 43.7793 46.3308 43.5588 46.602 43.5588Z",
    fill: "url(#paint9_linear_2510_31734)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3976 43.5588H43.7479C44.0191 43.5588 44.2395 43.7793 44.2395 44.0512V45.3661C44.2395 45.6373 44.0191 45.8577 43.7479 45.8577H35.3976C35.1257 45.8577 34.9053 45.6373 34.9053 45.3661V44.0512C34.906 43.7793 35.1257 43.5588 35.3976 43.5588Z",
    fill: "url(#paint10_linear_2510_31734)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.464 43.5588H32.3228C32.5947 43.5588 32.8151 43.7793 32.8151 44.0512V45.3661C32.8151 45.6373 32.5947 45.8577 32.3228 45.8577H16.464C16.1921 45.8577 15.9717 45.6373 15.9717 45.3661V44.0512C15.9717 43.7793 16.1921 43.5588 16.464 43.5588Z",
    fill: "url(#paint11_linear_2510_31734)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M38.379 52.534H16.464C16.1921 52.534 15.9717 52.3136 15.9717 52.0424V50.7274C15.9717 50.4555 16.1921 50.2351 16.464 50.2351H38.379C38.6502 50.2351 38.8706 50.4555 38.8706 50.7274V52.0424C38.8706 52.3136 38.6502 52.534 38.379 52.534Z",
    fill: "url(#paint12_linear_2510_31734)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5831 52.534H41.2328C40.9616 52.534 40.7412 52.3136 40.7412 52.0424V50.7274C40.7412 50.4555 40.9616 50.2351 41.2328 50.2351H49.5831C49.8551 50.2351 50.0755 50.4555 50.0755 50.7274V52.0424C50.0748 52.3136 49.8551 52.534 49.5831 52.534Z",
    fill: "url(#paint13_linear_2510_31734)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M38.379 59.2103H16.464C16.1921 59.2103 15.9717 58.9899 15.9717 58.7186V57.4037C15.9717 57.1318 16.1921 56.9114 16.464 56.9114H38.379C38.6502 56.9114 38.8706 57.1318 38.8706 57.4037V58.7186C38.8706 58.9899 38.6502 59.2103 38.379 59.2103Z",
    fill: "url(#paint14_linear_2510_31734)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7379 65.8865H16.464C16.1921 65.8865 15.9717 65.6661 15.9717 65.3949V64.08C15.9717 63.808 16.1921 63.5883 16.464 63.5883H50.7379C51.0091 63.5883 51.2296 63.808 51.2296 64.08V65.3949C51.2296 65.6668 51.0091 65.8865 50.7379 65.8865Z",
    fill: "url(#paint15_linear_2510_31734)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5169 65.8865H54.602C54.3308 65.8865 54.1104 65.6661 54.1104 65.3949V64.08C54.1104 63.808 54.3308 63.5883 54.602 63.5883H68.5169C68.7888 63.5883 69.0092 63.808 69.0092 64.08V65.3949C69.0092 65.6668 68.7888 65.8865 68.5169 65.8865Z",
    fill: "url(#paint16_linear_2510_31734)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5382 20.0433C53.5382 14.5865 48.5923 10.1638 42.4908 10.1638C36.3893 10.1638 31.4434 14.5865 31.4434 20.0433V22.3786C31.4434 27.8353 36.3893 32.258 42.4908 32.258C48.5923 32.258 53.5382 27.8353 53.5382 22.3786C53.5382 22.371 53.5382 20.0508 53.5382 20.0433Z",
    fill: "url(#paint17_linear_2510_31734)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M51.5894 14.4389C49.5967 11.8564 46.2651 10.1631 42.4906 10.1631C38.7168 10.1631 35.3852 11.8564 33.3926 14.4389V27.9823C35.3852 30.5654 38.7168 32.258 42.4906 32.258C46.2651 32.258 49.5967 30.5654 51.5894 27.9823V14.4389Z",
    fill: "url(#paint18_linear_2510_31734)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0107 30.3807C37.831 31.5611 40.0695 32.258 42.4906 32.258C44.911 32.258 47.1502 31.5611 48.9705 30.3807V12.0411C47.1502 10.8608 44.911 10.1638 42.4906 10.1638C40.0695 10.1638 37.831 10.8608 36.0107 12.0411V30.3807Z",
    fill: "url(#paint19_linear_2510_31734)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9805 32.0019C40.7866 32.1694 41.627 32.258 42.4902 32.258C43.3533 32.258 44.1937 32.1694 45.0005 32.0019V10.4199C44.1937 10.2524 43.354 10.1638 42.4902 10.1638C41.627 10.1638 40.7866 10.2524 39.9805 10.4199V32.0019Z",
    fill: "url(#paint20_linear_2510_31734)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5382 20.0433C53.5382 14.5865 48.5923 10.1638 42.4908 10.1638C36.3893 10.1638 31.4434 14.5865 31.4434 20.0433C31.4434 25.4994 36.3893 29.9227 42.4908 29.9227C48.5923 29.9227 53.5382 25.4994 53.5382 20.0433Z",
    fill: "url(#paint21_radial_2510_31734)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3053 20.0433C52.3053 15.1956 47.9115 11.2653 42.4904 11.2653C37.0693 11.2653 32.6748 15.1956 32.6748 20.0433C32.6748 24.8911 37.0693 28.8207 42.4904 28.8207C47.9115 28.8207 52.3053 24.8911 52.3053 20.0433Z",
    fill: "url(#paint22_radial_2510_31734)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3763 20.0433C51.3763 15.6543 47.3978 12.0967 42.4904 12.0967C37.5829 12.0967 33.6045 15.6543 33.6045 20.0433C33.6045 24.4316 37.5829 27.9898 42.4904 27.9898C47.3978 27.9898 51.3763 24.4316 51.3763 20.0433Z",
    fill: "url(#paint23_radial_2510_31734)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9951 23.1071L45.3074 15.4194C45.1983 15.2485 44.9868 15.1063 44.673 14.9937C44.3338 14.8722 43.9726 14.7891 43.5901 14.7438C43.5695 14.7307 43.5483 14.7191 43.527 14.7095L42.9605 14.1025C42.8712 14.0372 42.7751 14.0043 42.6728 14.0043C42.5602 14.0043 42.4641 14.0365 42.3851 14.1025C42.3054 14.1677 42.2656 14.2425 42.2656 14.327V14.7342C41.5076 14.8179 40.8738 15.0706 40.3636 15.4915C39.8534 15.9131 39.5987 16.5298 39.5987 17.3427C39.5987 17.6318 39.6316 17.8962 39.6976 18.1344C39.7628 18.372 39.8706 18.5801 40.0203 18.7572C40.1693 18.9351 40.3121 19.0868 40.4481 19.2125C40.4487 19.2139 40.4501 19.2145 40.4508 19.2152C40.4508 19.2152 42.2162 20.9799 42.2169 20.9813C42.2333 20.9984 42.2491 21.0149 42.2656 21.0321V23.3797C41.8509 23.3516 41.4856 23.2445 41.1704 23.057C40.8546 22.8709 40.606 22.6958 40.4254 22.5324C40.2448 22.369 40.0992 22.2873 39.988 22.2873C39.8205 22.2873 39.6721 22.3759 39.5417 22.553C39.4112 22.7309 39.3467 22.908 39.3467 23.0858C39.3467 23.3694 39.506 23.6489 39.826 23.9242L45.4626 29.5609C49.0215 28.6738 51.856 26.2327 52.9951 23.1071Z",
    fill: "url(#paint24_linear_2510_31734)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3457 23.0851C39.3457 22.908 39.4109 22.7301 39.5414 22.553C39.6712 22.3758 39.8202 22.2865 39.9877 22.2865C40.0983 22.2865 40.2445 22.3689 40.4251 22.5317C40.6057 22.6958 40.8536 22.8709 41.1694 23.057C41.4853 23.2437 41.8506 23.3515 42.2653 23.379V20.0879C41.9845 19.9849 41.7689 19.9032 41.6199 19.8428C41.4695 19.7823 41.2711 19.6931 41.0232 19.577C40.7753 19.4603 40.583 19.3388 40.4478 19.2124C40.3118 19.0868 40.169 18.935 40.0193 18.7572C39.8696 18.58 39.7618 18.372 39.6966 18.1337C39.6313 17.8954 39.5984 17.6318 39.5984 17.3427C39.5984 16.5297 39.8531 15.9124 40.3633 15.4915C40.8728 15.0706 41.5073 14.8179 42.2653 14.7334V14.327C42.2653 14.2425 42.3051 14.1676 42.3841 14.1024C42.4638 14.0365 42.5599 14.0035 42.6725 14.0035C42.7748 14.0035 42.8709 14.0365 42.9602 14.1024C43.0488 14.1676 43.0934 14.2425 43.0934 14.327V14.7053C43.664 14.7245 44.19 14.8206 44.672 14.993C45.154 15.1667 45.3951 15.407 45.3951 15.716C45.3951 15.8843 45.3381 16.06 45.2248 16.2427C45.1122 16.4247 44.9611 16.516 44.7723 16.516C44.6981 16.516 44.4928 16.437 44.1577 16.2777C43.8226 16.1184 43.4676 16.025 43.0934 15.9969V18.841C43.4656 18.981 43.7746 19.1142 44.0211 19.2406C44.2676 19.3669 44.5285 19.5413 44.8032 19.7659C45.0778 19.9897 45.2845 20.2726 45.4239 20.6132C45.5633 20.9538 45.6333 21.3534 45.6333 21.8107C45.6333 22.6463 45.4053 23.311 44.9494 23.804C44.4935 24.297 43.8748 24.5999 43.0934 24.7125V25.1814C43.0934 25.2645 43.0488 25.3373 42.9602 25.4019C42.8709 25.4664 42.7748 25.4987 42.6725 25.4987C42.5599 25.4987 42.4638 25.4664 42.3841 25.4019C42.3051 25.338 42.2653 25.2645 42.2653 25.1814V24.7543C41.451 24.7454 40.7609 24.5593 40.1951 24.1961C39.6286 23.8329 39.3457 23.4628 39.3457 23.0851ZM40.9882 17.2026C40.9882 17.5672 41.1015 17.8446 41.3287 18.0362C41.5553 18.2271 41.8959 18.407 42.3498 18.5752V16.0237C41.442 16.1356 40.9882 16.529 40.9882 17.2026ZM43.009 23.3515C43.8322 23.2018 44.2442 22.7397 44.2442 21.9645C44.2442 21.5539 44.1364 21.2319 43.9215 20.9984C43.7059 20.7649 43.4024 20.5644 43.009 20.3962V23.3515Z",
    fill: "url(#paint25_linear_2510_31734)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2510_31734",
    x1: 19.4695,
    y1: 18.6113,
    x2: 94.4382,
    y2: 93.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2510_31734",
    x1: 71.6157,
    y1: 50.3371,
    x2: 24.7871,
    y2: 3.50849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.290196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592157
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.839216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2510_31734",
    x1: 83.7454,
    y1: 28.9169,
    x2: 80.8801,
    y2: 6.28116,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2510_31734",
    x1: 61.3394,
    y1: 105.717,
    x2: 35.5564,
    y2: 79.9345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0DDFC",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#C8B7E0",
    stopOpacity: 0.290196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#A595C8",
    stopOpacity: 0.592157
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8F81B8",
    stopOpacity: 0.839216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2510_31734",
    x1: 33.2609,
    y1: 75.5409,
    x2: 33.2609,
    y2: 84.1576,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2510_31734",
    x1: 66.764,
    y1: 87.4959,
    x2: 67.1601,
    y2: 87.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F7FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0DDFC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2510_31734",
    x1: 27.4213,
    y1: 29.2331,
    x2: 27.4213,
    y2: 65.1863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2510_31734",
    x1: 45.4082,
    y1: 29.2331,
    x2: 45.4082,
    y2: 65.1863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2510_31734",
    x1: 60.5878,
    y1: 29.2331,
    x2: 60.5878,
    y2: 65.1863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2510_31734",
    x1: 57.5597,
    y1: 53.507,
    x2: 57.5597,
    y2: 17.5538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2510_31734",
    x1: 39.5726,
    y1: 53.507,
    x2: 39.5726,
    y2: 17.5538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2510_31734",
    x1: 24.3933,
    y1: 53.507,
    x2: 24.3933,
    y2: 17.5538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2510_31734",
    x1: 27.4213,
    y1: 42.5859,
    x2: 27.4213,
    y2: 78.5391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2510_31734",
    x1: 45.4082,
    y1: 42.5859,
    x2: 45.4082,
    y2: 78.5391,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2510_31734",
    x1: 27.4213,
    y1: 49.2623,
    x2: 27.4213,
    y2: 85.2155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2510_31734",
    x1: 33.6008,
    y1: 55.9387,
    x2: 33.6008,
    y2: 91.8919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2510_31734",
    x1: 61.5596,
    y1: 55.9387,
    x2: 61.5596,
    y2: 91.8919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4F4A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B395F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2510_31734",
    x1: 31.4434,
    y1: 21.2109,
    x2: 53.5382,
    y2: 21.2109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#FEC33A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4454,
    stopColor: "#FBB840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6474,
    stopColor: "#F6A649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8426,
    stopColor: "#F08D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2510_31734",
    x1: 41.439,
    y1: 19.1886,
    x2: 50.5193,
    y2: 36.6507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA17A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.152,
    stopColor: "#F69373",
    stopOpacity: 0.152941
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.416,
    stopColor: "#EF816B",
    stopOpacity: 0.415686
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6926,
    stopColor: "#EA7666",
    stopOpacity: 0.694118
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2510_31734",
    x1: 42.1507,
    y1: 24.6584,
    x2: 41.0782,
    y2: 35.5365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2510_31734",
    x1: 40.3021,
    y1: 25.2128,
    x2: 36.9867,
    y2: 31.2765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_2510_31734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.4062 12.8914) scale(20.8293 18.6276)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#FEC33A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4454,
    stopColor: "#FBB840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6474,
    stopColor: "#F6A649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8426,
    stopColor: "#F08D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97264"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_2510_31734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.2508 22.5541) rotate(180) scale(15.3619 13.7381)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#FEC33A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4454,
    stopColor: "#FBB840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6474,
    stopColor: "#F6A649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8426,
    stopColor: "#F08D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97264"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_2510_31734",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.9788 15.1804) scale(17.2947 15.4667)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2344,
    stopColor: "#FEC33A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4454,
    stopColor: "#FBB840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6474,
    stopColor: "#F6A649"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8426,
    stopColor: "#F08D56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97264"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2510_31734",
    x1: 48.642,
    y1: 24.5898,
    x2: 35.6555,
    y2: 16.0646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E97264",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2510_31734",
    x1: 45.0112,
    y1: 19.7514,
    x2: 35.1114,
    y2: 19.7514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E97264"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.5d4fca2c6cd6ab476298eca9a7888dcf.svg";
export { ForwardRef as ReactComponent };